import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  vehicle: [],
  loading: false,
  error: null,
};

const initialStateForGroup: any = {
  vehicleGroup: [],
  loading: false,
  error: null,
};

// Vehicle slice
const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    vehicleRequest(state) {
      state.loading = true;
      state.error = null;
    },
    vehicleSuccess(state, action) {
      state.loading = false;
      state.vehicle = action.payload;
    },
    vehicleAddSuccess(state, action) {
      state.loading = false;
      state.vehicle.push(action.payload);
    },
    vehicleEditSuccess(state, action) {
      state.loading = false;
      state.vehicle = state.vehicle.map((vehicle: { id: any }) =>
        vehicle.id === action.payload.id ? action.payload : vehicle
      );
    },
    vehicleDeleteSuccess(state, action) {
      state.loading = false;
      state.vehicle = state.vehicle.filter((vehicle: { id: any }) => vehicle.id !== action.payload);
    },
    vehicleError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getVehicleByIdRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getVehicleByIdSuccess(state, action) {
      state.loading = false;
      state.user = action.payload;  // Store the user fetched by ID in `user`
    },
    getVehicleByIdError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Vehicle Group slice
const vehicleGroupSlice = createSlice({
  name: "vehicleGroup",
  initialState: initialStateForGroup,
  reducers: {
    vehicleGroupRequest(state) {
      state.loading = true;
      state.error = null;
    },
    vehicleGroupSuccess(state, action) {
      state.loading = false;
      state.vehicleGroup = action.payload;
    },
    vehicleGroupAddSuccess(state, action) {
      state.loading = false;
      state.vehicleGroup.push(action.payload);
    },
    vehicleGroupEditSuccess(state, action) {
      state.loading = false;
      state.vehicleGroup = state.vehicleGroup.map((vehicleGroup: { id: any }) =>
        vehicleGroup.id === action.payload.id ? action.payload : vehicleGroup
      );
    },
    vehicleGroupDeleteSuccess(state, action) {
      state.loading = false;
      state.vehicleGroup = state.vehicleGroup.filter((vehicleGroup: { id: any }) => vehicleGroup.id !== action.payload);
    },
    vehicleGroupError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions
export const {
  vehicleRequest,
  vehicleSuccess,
  vehicleAddSuccess,
  vehicleEditSuccess,
  vehicleDeleteSuccess,
  getVehicleByIdRequest,
  getVehicleByIdSuccess,
  getVehicleByIdError,
  vehicleError,
} = vehicleSlice.actions;

export const {
  vehicleGroupRequest,
  vehicleGroupSuccess,
  vehicleGroupAddSuccess,
  vehicleGroupEditSuccess,
  vehicleGroupDeleteSuccess,
  vehicleGroupError,
} = vehicleGroupSlice.actions;

// Export reducers separately
export const vehicleReducer = vehicleSlice.reducer;
export const vehicleGroupReducer = vehicleGroupSlice.reducer;
